import React from "react";
import { TableCell } from "@mui/material";

const DSTableCell = (props: React.ComponentProps<typeof TableCell>) => {
  return <TableCell {...props} />;
};

export default DSTableCell;
